import { Controller } from "@hotwired/stimulus";

// Every side group's columns are rendered server-side so the nav stays cacheable and crawlable;
// this only decides which is visible.
export default class extends Controller {
  static targets = ["sideGroup", "panel"];

  connect() {
    this.activate(0);
  }

  select(event) {
    this.activate(Number(event.params.index));
  }

  reset() {
    this.activate(0);
  }

  activate(index) {
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("megamenu-panel-active", i === index);
    });

    this.sideGroupTargets.forEach((item, i) => {
      const active = i === index;

      item.classList.toggle("megamenu-side-group-active", active);
      item.setAttribute("aria-expanded", active);
    });
  }
}
